<div class="agency-header">
  @if (authenticationService.hasRole('ROLE_ROOT_ADMIN')) {
  <div class="admin">
      <fa-icon [icon]="faUserSecret"></fa-icon>  Simulated Agency: {{authenticationService.currentUserValue.userAccountLightDto?.agency?.agencyName}}
  </div>
  }
  @if (authenticationService.isAuthenticated() && !authenticationService.hasRole('ROLE_ROOT_ADMIN')) {
  <div>
    Welcome {{ authenticationService.currentUserValue.userAccountLightDto?.firstName ? authenticationService.currentUserValue.userAccountLightDto?.firstName + ' ' + authenticationService.currentUserValue.userAccountLightDto?.lastName : authenticationService.currentUserValue.username }}
    of {{authenticationService.currentUserValue.userAccountLightDto?.agency?.agencyName}}
  </div>
  }

</div>
